<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div
          v-if="popUp.path"
          class="container w-full mx-auto bg-white bg-center bg-cover bg-no-repeat md:rounded"
          :style="{
            'background-image': 'url(' + popUp.path + ')',
            height: '48vh',
            position: 'relative',
            zIndex: '1',
            'max-height': '200px',
          }"
        ></div>
      </div>
      <div class="vx-col w-full mt-5">
        <h3 class="mb-4">
          <strong>{{ $t("InfoGeneral") }}</strong>
        </h3>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="vx-col w-full mb-3">
          <label
            ><strong>{{ $t("Url") }}</strong></label
          >
          <p>{{ popUp.url }}</p>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="vx-col w-full mb-3">
          <!------
          <label
            ><strong>{{ $t("StartedAt") }} </strong></label
          >
          <p>{{ popUp.started_at }}</p>
          ----->
          <label
            ><strong>{{ $t("Estado") }}</strong></label
          >
          <p>{{ state }}</p>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="vx-col w-full mb-3">
          <label
            ><strong>{{ $t("StartedAt") }} </strong></label
          >
          <p>{{ popUp.started_at }}</p>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="vx-col w-full mb-3">
          <label
            ><strong>{{ $t("FinishedAt") }} </strong></label
          >
          <p v-if="popUp.finished_at !== '9999-12-31'">
            {{ popUp.finished_at }}
          </p>

          <p v-if="popUp.finished_at === '9999-12-31'">
            <strong>{{ $t("popUps.Permanent") }} </strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import ImageDropzone from "../ImageDropzone.vue";
import TimeRangeInput from "../time-range-input/TimeRangeInput.vue";
import CalendarRangeInput from "../calendar-range-input/CalendarRangeInput.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    ImageDropzone,
    draggable,
    TimeRangeInput,
    CalendarRangeInput,
  },
  props: {
    popUp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      popUpForm: {},
      popUpFormOriginal: {},
      myFile: "",
      popUpImages: {},
      started_at: null,
      finished_at: null,
      image: "",
      url: "",
      state: "",
    };
  },
  created() {
    const files = new Array();
    const m = this.popUp.path.match(/.*\/(.+?)\./);
    let name = this.popUp.path;
    this.state = this.popUp.active === 0 ? "Desactivado" : "Activado";
    if (m && m.length > 1) {
      name = m[1];
    }
    const image = {
      name,
      url: this.popUp.path,
    };
    files.push(image);

    this.popUpImages = files;
  },
  computed: {
    ...mapGetters({
      currentRestaurant: "getCurrentRestaurant",
    }),

    dateRange: {
      set(val) {
        this.popUpForm.started_at = val.fromDate;
        this.popUpForm.finished_at = val.toDate;
      },
      get() {
        return {
          fromDate: this.popUpForm.started_at,
          toDate: this.popUpForm.finished_at,
        };
      },
    },

    currentPage: {
      get() {
        return this.currentPageNumber;
      },
      set(currentPageNumber) {
        this.currentPageNumber = currentPageNumber;
        return this.currentPageNumber;
      },
    },
  },
  methods: {
    resetForm() {
      Object.assign(this.$data, this.returnInitialData());
      this.$refs.images.emptyDropzone();
      this.$refs.form.reset();
    },
    ...mapActions({
      editPopUp: "editPopUp",
    }),
    ...mapMutations({
      setPopUp: "setItemPopUp",
      loading: "loading",
      setpopupEditPopUp: "setpopupEditPopUp",
    }),
  },
  destroyed() {
    this.$store.commit("setpopupEditPopUp", false);
  },
};
</script>
<style></style>
